module.exports = __webpack_public_path__ + "img/sr-quotes.c94fb744.png";